"use strict";

var _require = require('./Component'),
    ReactElementResize = _require.ReactElementResize;

ReactElementResize.ReactElementResize = ReactElementResize;
module.exports = ReactElementResize;